export default __webpack_public_path__ + "static/media/meeting-room-gray.8d8e8239.svg";